// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".services[data-v-537249b8]{padding:80px 0;background-color:#f8f9fa;margin-top:600px}.main-title[data-v-537249b8]{color:green;font-size:1.8rem;font-weight:700}.main-description[data-v-537249b8]{color:#6c757d;font-size:1.1rem}.service-description[data-v-537249b8]{color:#495057}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
